import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import {urls} from "../../services/apiService"
// Function to get saved fields from PostgreSQL using the user's email
export const getSavedFieldsFromPostgres = async () => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User must be authenticated to retrieve saved fields.");
  }

  const userEmail = user.email; // Get the user's email from Firebase Auth
  try {
    const response = await fetch(
      `${urls.get_fieldnames}?username=${encodeURIComponent(userEmail)}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch saved fields");
    }

    const data = await response.json();
   
    return data.fields || []; // Return the list of saved field names
  } catch (error) {
    console.error("Error fetching saved fields:", error);
    return [];
  }
};

export const compareFields = async () => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User must be authenticated to retrieve field data.");
  }

  const db = getFirestore();
  const fieldsCollectionRef = collection(db, `users/${user.uid}/fields`);
  const querySnapshot = await getDocs(fieldsCollectionRef);
  const firebaseFields = querySnapshot.docs.map((doc) => doc.data().fieldName);


  // Get saved fields from PostgreSQL
  const savedFields = await getSavedFieldsFromPostgres();

  // Extract only the field names from the saved fields in PostgreSQL
  const savedFieldNames = savedFields.map((savedField) => savedField.fieldname);



  // Create an object mapping field names to their existence in both databases
  const fieldExistence = firebaseFields.reduce((acc, field) => {
    const fieldExistsInPostgres = savedFieldNames.includes(field);
    acc[field] = fieldExistsInPostgres; // true if exists in PostgreSQL
    return acc;
  }, {});
  // Fetch data for fields that exist in both databases
  for (const field in fieldExistence) {
    if (fieldExistence[field]) {
      await fetchResults(field);
    }
  }

  return fieldExistence; // Return the mapping of field names to existence
};


// Utility function to format date to mm/dd/yyyy
const formatDate = (date) => {
  const d = new Date(date);
  const month = ('0' + (d.getMonth() + 1)).slice(-2); // Add leading zero
  const day = ('0' + d.getDate()).slice(-2); // Add leading zero
  const year = d.getFullYear();
  return `${month}/${day}/${year}`;
};

export const fetchResults = async (field) => {
  const resultsApiUrl = urls.get_results;
  const dataToSend = {
    fieldName: field,
    indexType: "NDVI",  // Specify the appropriate index type (e.g., NDVI, NDRE, etc.)
  };
  try {
    const response = await fetch(resultsApiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataToSend),
    });


    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server error message:", errorText);
      throw new Error(`Failed to fetch results for field: ${field}`);
    }

    const data = await response.json();


    if (data.results && data.results.length > 0) {
      const lastResult = data.results[data.results.length - 1];
      const lastDate = lastResult.Date;
      

      return lastDate;
    } else {

      return null;
    }

  } catch (error) {
    console.error(`Error fetching results for field ${field}:`, error);
    return null;
  }
};
